<template>
  <div>
    <date-picker
      ref="datePicker"
      v-model="value"
      :disabled="disabled"
      :disabled-date="maxDate"
      format="DD/MMMM/YYYY"
      :inline="true"
      :lang="lang"
      title-format="MMMM/YYYY"
      :type="calendarType"
      value-type="date"
      @input="sendValue"
    />
    <p v-if="error" class="error">
      <em class="fa fa-times-circle" />
      <span>{{ customErrorMsg }}</span>
    </p>
  </div>
</template>

<script>
import { datetime } from 'rrule';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';

export default {
  name: 'CustomDatepickerVue2',
  components: { DatePicker },
  props: {
    calendarType: {
      type: String,
      default: 'date',
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxDate: {
      type: datetime,
      default: null,
    },
  },
  data() {
    return {
      value: null,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          firstWeekContainsDate: 7,
          monthsShort: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre',
          ],
          weekdaysMin: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
        },
      },
    };
  },
  methods: {
    sendValue() {
      this.$emit('calendar-input', this.value);
    },
  },
};
</script>

<style lang="scss">
.error {
  color: #ff7058;
  font-size: 18px;
  padding-right: 10px;
  & > span {
    padding-left: 10px;
    font-size: 14px;
    font-weight: normal;
  }
}
$orange: #ff7059;
$black: #000;
$light-gray: #f8f8f8;

$default-color: #555;
$primary-color: $orange;
$popup-z-index: 0;

.mx-datepicker.mx-datepicker-range {
  width: 100% !important;
}
.mx-datepicker-main {
  border-radius: 4px;
  font-family: 'Lato' !important;
  color: #000 !important;
}

.mx-table-date thead {
  background-color: #f8f8f8;
}
.mx-table-date tbody {
  background-color: transparent;
}
.mx-table-date td,
.mx-table-date th {
  font-weight: bold !important;
  font-size: 13px !important;
}
.mx-calendar-content .cell.active {
  border-radius: 50%;
}
.mx-calendar-content .cell.disabled {
  color: #000 !important;
  background-color: transparent !important;
}
.mx-table-date .cell.not-current-month {
  color: #000 !important;
}

.mx-calendar-header {
  margin-bottom: 7px !important;
}

.mx-calendar-header > button {
  background: #f8f8f8;
  border-radius: 50%;
  padding: 0px 10px;
  margin-bottom: 5px !important;
}

.mx-calendar-header > button:hover {
  background: darken(#f8f8f8, 5%);
}

.mx-btn.mx-btn-text.mx-btn-current-month,
.mx-btn.mx-btn-text.mx-btn-current-year {
  font: Bold 13px/20px Lato;
  color: #000 !important;
}

.mx-calendar-header-label:hover {
  background: #eee;
  padding: 3px 10px;
}

.mx-datepicker {
  width: 300px !important;
  & .mx-calendar.mx-calendar-panel-date.mx-calendar-week-mode,
  .mx-calendar.mx-calendar-panel-date {
    width: 100% !important;
  }
}

.mx-table.mx-table-date > tbody > tr > td:hover {
  border: 1px solid #4bd !important;
}

@import 'node_modules/vue2-datepicker/scss/index.scss';
</style>
